import React from 'react';
import { render } from 'react-dom';
import honeycombWebSDK from './honeycomb/sdk';

try {
  honeycombWebSDK.start();
} catch (error) {
  console.error('Failed to start Honeycomb Web SDK:', error);
}

const COMPONENT_ATTRIBUTE = 'data-react-component';
const COMPONENT_PROPS_ATTRIBUTE = 'data-react-props';

function doMount(components) {
  const componentWithProviders = (Component) => (props) => (
    <React.StrictMode>
      <Component {...props} />
    </React.StrictMode>
  );

  // Retrieve component mount points and their props following this pattern:
  // <div data-react-component="name" data-react-props="<%= some_props.to_json %>"></div>
  for (const containerElement of document.querySelectorAll(`[${COMPONENT_ATTRIBUTE}]`)) {
    const name = containerElement.getAttribute(COMPONENT_ATTRIBUTE);
    const props = readJsonData(containerElement, COMPONENT_PROPS_ATTRIBUTE);

    if (name && Object.prototype.hasOwnProperty.call(components, name)) {
      const Component = componentWithProviders(components[name]);
      render(<Component {...props} />, containerElement);
    } else if (process.env.NODE_ENV === 'development') {
      console.warn(`Cannot mount unknown component '${name}'.\nUse one of: ${Object.keys(components).join(', ')}.`);
    }
  }
}

function readJsonData(element, attribute) {
  const text = attribute ? element?.getAttribute(attribute) : element?.textContent;
  const data = typeof text === 'string' ? JSON.parse(text.trim() || 'null') : null;
  if (data != null && typeof data === 'object') {
    return data;
  }
  return {};
}

export default function register(components) {
  const onReady = () => {
    doMount(components);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
}
